module.exports = __webpack_public_path__ + "static/media/more.f6b1ad6b.svg";